/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as containerRouteRouteImport } from './routes/(container)/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as containerStudyRouteImport } from './routes/(container)/study'
import { Route as containerStatsRouteImport } from './routes/(container)/stats'
import { Route as containerSettingsRouteImport } from './routes/(container)/settings'
import { Route as containerOverviewRouteImport } from './routes/(container)/overview'
import { Route as containerImportRouteImport } from './routes/(container)/import'
import { Route as containerGamesRouteImport } from './routes/(container)/games'
import { Route as containerAnalyzeIndexRouteImport } from './routes/(container)/analyze/index'
import { Route as containerAnalyzeSlugRouteImport } from './routes/(container)/analyze/$slug'

const containerRouteRoute = containerRouteRouteImport.update({
  id: '/(container)',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const containerStudyRoute = containerStudyRouteImport.update({
  id: '/study',
  path: '/study',
  getParentRoute: () => containerRouteRoute,
} as any)
const containerStatsRoute = containerStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => containerRouteRoute,
} as any)
const containerSettingsRoute = containerSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => containerRouteRoute,
} as any)
const containerOverviewRoute = containerOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => containerRouteRoute,
} as any)
const containerImportRoute = containerImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => containerRouteRoute,
} as any)
const containerGamesRoute = containerGamesRouteImport.update({
  id: '/games',
  path: '/games',
  getParentRoute: () => containerRouteRoute,
} as any)
const containerAnalyzeIndexRoute = containerAnalyzeIndexRouteImport.update({
  id: '/analyze/',
  path: '/analyze/',
  getParentRoute: () => containerRouteRoute,
} as any)
const containerAnalyzeSlugRoute = containerAnalyzeSlugRouteImport.update({
  id: '/analyze/$slug',
  path: '/analyze/$slug',
  getParentRoute: () => containerRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof containerRouteRouteWithChildren
  '/games': typeof containerGamesRoute
  '/import': typeof containerImportRoute
  '/overview': typeof containerOverviewRoute
  '/settings': typeof containerSettingsRoute
  '/stats': typeof containerStatsRoute
  '/study': typeof containerStudyRoute
  '/analyze/$slug': typeof containerAnalyzeSlugRoute
  '/analyze': typeof containerAnalyzeIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof containerRouteRouteWithChildren
  '/games': typeof containerGamesRoute
  '/import': typeof containerImportRoute
  '/overview': typeof containerOverviewRoute
  '/settings': typeof containerSettingsRoute
  '/stats': typeof containerStatsRoute
  '/study': typeof containerStudyRoute
  '/analyze/$slug': typeof containerAnalyzeSlugRoute
  '/analyze': typeof containerAnalyzeIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(container)': typeof containerRouteRouteWithChildren
  '/(container)/games': typeof containerGamesRoute
  '/(container)/import': typeof containerImportRoute
  '/(container)/overview': typeof containerOverviewRoute
  '/(container)/settings': typeof containerSettingsRoute
  '/(container)/stats': typeof containerStatsRoute
  '/(container)/study': typeof containerStudyRoute
  '/(container)/analyze/$slug': typeof containerAnalyzeSlugRoute
  '/(container)/analyze/': typeof containerAnalyzeIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/games'
    | '/import'
    | '/overview'
    | '/settings'
    | '/stats'
    | '/study'
    | '/analyze/$slug'
    | '/analyze'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/games'
    | '/import'
    | '/overview'
    | '/settings'
    | '/stats'
    | '/study'
    | '/analyze/$slug'
    | '/analyze'
  id:
    | '__root__'
    | '/'
    | '/(container)'
    | '/(container)/games'
    | '/(container)/import'
    | '/(container)/overview'
    | '/(container)/settings'
    | '/(container)/stats'
    | '/(container)/study'
    | '/(container)/analyze/$slug'
    | '/(container)/analyze/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  containerRouteRoute: typeof containerRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(container)': {
      id: '/(container)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof containerRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(container)/study': {
      id: '/(container)/study'
      path: '/study'
      fullPath: '/study'
      preLoaderRoute: typeof containerStudyRouteImport
      parentRoute: typeof containerRouteRoute
    }
    '/(container)/stats': {
      id: '/(container)/stats'
      path: '/stats'
      fullPath: '/stats'
      preLoaderRoute: typeof containerStatsRouteImport
      parentRoute: typeof containerRouteRoute
    }
    '/(container)/settings': {
      id: '/(container)/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof containerSettingsRouteImport
      parentRoute: typeof containerRouteRoute
    }
    '/(container)/overview': {
      id: '/(container)/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof containerOverviewRouteImport
      parentRoute: typeof containerRouteRoute
    }
    '/(container)/import': {
      id: '/(container)/import'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof containerImportRouteImport
      parentRoute: typeof containerRouteRoute
    }
    '/(container)/games': {
      id: '/(container)/games'
      path: '/games'
      fullPath: '/games'
      preLoaderRoute: typeof containerGamesRouteImport
      parentRoute: typeof containerRouteRoute
    }
    '/(container)/analyze/': {
      id: '/(container)/analyze/'
      path: '/analyze'
      fullPath: '/analyze'
      preLoaderRoute: typeof containerAnalyzeIndexRouteImport
      parentRoute: typeof containerRouteRoute
    }
    '/(container)/analyze/$slug': {
      id: '/(container)/analyze/$slug'
      path: '/analyze/$slug'
      fullPath: '/analyze/$slug'
      preLoaderRoute: typeof containerAnalyzeSlugRouteImport
      parentRoute: typeof containerRouteRoute
    }
  }
}

interface containerRouteRouteChildren {
  containerGamesRoute: typeof containerGamesRoute
  containerImportRoute: typeof containerImportRoute
  containerOverviewRoute: typeof containerOverviewRoute
  containerSettingsRoute: typeof containerSettingsRoute
  containerStatsRoute: typeof containerStatsRoute
  containerStudyRoute: typeof containerStudyRoute
  containerAnalyzeSlugRoute: typeof containerAnalyzeSlugRoute
  containerAnalyzeIndexRoute: typeof containerAnalyzeIndexRoute
}

const containerRouteRouteChildren: containerRouteRouteChildren = {
  containerGamesRoute: containerGamesRoute,
  containerImportRoute: containerImportRoute,
  containerOverviewRoute: containerOverviewRoute,
  containerSettingsRoute: containerSettingsRoute,
  containerStatsRoute: containerStatsRoute,
  containerStudyRoute: containerStudyRoute,
  containerAnalyzeSlugRoute: containerAnalyzeSlugRoute,
  containerAnalyzeIndexRoute: containerAnalyzeIndexRoute,
}

const containerRouteRouteWithChildren = containerRouteRoute._addFileChildren(
  containerRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  containerRouteRoute: containerRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
